export enum RoleName {
    admin = 'admin',
    labo = 'labo',
    admin_labo = 'admin_labo',
    driver = 'driver'
}
